import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "inline-items" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark fa-w-12 mr-1 text-warning" }, null, -1)
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = { class: "text-lg-right" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_12 = { class: "card pb-0" }
const _hoisted_13 = { class: "row align-items-center" }
const _hoisted_14 = { class: "col-md-5" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "" }
const _hoisted_17 = { class: "input-btn" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { for: "" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { for: "" }
const _hoisted_24 = { class: "col-md-1" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sync-alt" }, null, -1)
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "card p-0" }
const _hoisted_28 = { class: "table-responsive" }
const _hoisted_29 = { class: "table mb-0 table-shadowed" }
const _hoisted_30 = { class: "table-primary" }
const _hoisted_31 = { scope: "col" }
const _hoisted_32 = { scope: "col to-upper" }
const _hoisted_33 = { scope: "col" }
const _hoisted_34 = { scope: "col" }
const _hoisted_35 = { scope: "col" }
const _hoisted_36 = { scope: "col" }
const _hoisted_37 = { scope: "col" }
const _hoisted_38 = { scope: "col" }
const _hoisted_39 = { scope: "col" }
const _hoisted_40 = { scope: "col" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { colspan: "9" }
const _hoisted_62 = { class: "modal-wrap default-modal" }
const _hoisted_63 = {
  class: "modal fade",
  id: "model1",
  tabindex: "-1",
  "aria-labelledby": "model1Label",
  "aria-hidden": "true"
}
const _hoisted_64 = { class: "modal-dialog" }
const _hoisted_65 = { class: "modal-content" }
const _hoisted_66 = { class: "modal-header" }
const _hoisted_67 = {
  class: "modal-title to-upper",
  id: "model1Label"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 12/12/2022, 12.23 p.m")
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = { for: "" }
const _hoisted_73 = /*#__PURE__*/_createVNode("textarea", {
  class: "form-control",
  rows: "5"
}, null, -1)
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = {
  class: "btn default-btn mr-2",
  type: "submit"
}
const _hoisted_76 = {
  class: "btn default-btn outline",
  type: "submit"
}
const _hoisted_77 = { class: "modal-footer" }
const _hoisted_78 = {
  type: "button",
  class: "btn default-btn"
}
const _hoisted_79 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_80 = { class: "modal-wrap default-modal" }
const _hoisted_81 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "taskCompleteImages",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_82 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_83 = { class: "modal-content" }
const _hoisted_84 = { class: "modal-header" }
const _hoisted_85 = { class: "d-block" }
const _hoisted_86 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_87 = { class: "text-muted" }
const _hoisted_88 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_89 = { class: "modal-body" }
const _hoisted_90 = { class: "form-wrap pt-0" }
const _hoisted_91 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_92 = { class: "modal-wrap default-modal" }
const _hoisted_93 = {
  class: "modal fade",
  id: "model2",
  tabindex: "-2",
  "aria-labelledby": "model2Label",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "modal-dialog" }
const _hoisted_95 = { class: "modal-content" }
const _hoisted_96 = { class: "modal-header" }
const _hoisted_97 = {
  class: "modal-title",
  id: "model2Label"
}
const _hoisted_98 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_99 = { class: "modal-body" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" $1000.00")
const _hoisted_101 = { class: "bg-light p-2" }
const _hoisted_102 = { class: "to-upper" }
const _hoisted_103 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_104 = /*#__PURE__*/_createVNode("p", { class: "text-success" }, "20% Paid", -1)
const _hoisted_105 = { class: "text-danger" }
const _hoisted_106 = { class: "modal-footer" }
const _hoisted_107 = {
  type: "button",
  class: "btn default-btn"
}
const _hoisted_108 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_109 = { class: "modal-wrap default-modal" }
const _hoisted_110 = {
  class: "modal fade",
  id: "model3",
  tabindex: "-3",
  "aria-labelledby": "model3Label",
  "aria-hidden": "true"
}
const _hoisted_111 = { class: "modal-dialog" }
const _hoisted_112 = { class: "modal-content" }
const _hoisted_113 = { class: "modal-header" }
const _hoisted_114 = {
  class: "modal-title",
  id: "model3Label"
}
const _hoisted_115 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_116 = { class: "modal-body" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" $1000.00")
const _hoisted_118 = { class: "bg-light p-2 mb-3" }
const _hoisted_119 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_120 = /*#__PURE__*/_createVNode("p", { class: "text-warning" }, "Partial Paid", -1)
const _hoisted_121 = /*#__PURE__*/_createVNode("p", { class: "text-success" }, "Full Paid.", -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createVNode("label", { for: "" }, "Percent to pay"),
  /*#__PURE__*/_createVNode("input", {
    type: "text",
    class: "form-control",
    placeholder: "$10"
  })
], -1)
const _hoisted_123 = { class: "modal-footer" }
const _hoisted_124 = {
  type: "button",
  class: "btn default-btn"
}
const _hoisted_125 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoListBreadCrumb = _resolveComponent("ToDoListBreadCrumb")
  const _component_big = _resolveComponent("big")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_ctx.state.ui.isLoading.getPhaseLogList)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_3, [
        _createVNode(_component_ToDoListBreadCrumb, {
          project: _ctx.state.data.logList.project,
          breadCrumbEndPoint: _ctx.state.data.endPoint
        }, null, 8, ["project", "breadCrumbEndPoint"]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode("strong", null, [
                      _hoisted_8,
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('logs')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn outline d-inline-block",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToToDoDetails && _ctx.redirectToToDoDetails(...args)))
                }, [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('go_back')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('search_by_name')), 1),
                _createVNode("div", _hoisted_17, [
                  _withDirectives(_createVNode("input", {
                    id: "searchTemplateByText",
                    type: "text",
                    class: "form-control",
                    placeholder: "Search for Name eg.Searchable, Convorally.",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.filterBy.name = $event)),
                    autocomplete: "off",
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.getPhaseLogList && _ctx.getPhaseLogList(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.state.data.filterBy.name]
                  ]),
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn default-btn",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getPhaseLogList && _ctx.getPhaseLogList(...args)))
                  }, _toDisplayString(_ctx.$t('search')), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('from')), 1),
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.filterBy.fromDate = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.filterBy.fromDate]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('to')), 1),
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.filterBy.toDate = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.filterBy.toDate]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("button", {
                id: "clearTodoList",
                class: "add-templete-btn",
                title: "clear",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearGetData && _ctx.clearGetData(...args)))
              }, [
                _hoisted_25
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_ErrorList, {
                class: "mt-0",
                errors: _ctx.state.ui.error.errorList.getPhaseLogList,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("table", _hoisted_29, [
              _createVNode("thead", _hoisted_30, [
                _createVNode("tr", null, [
                  _createVNode("th", _hoisted_31, _toDisplayString(_ctx.$t('date')), 1),
                  _createVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('task')), 1),
                  _createVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('username')), 1),
                  _createVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('email')), 1),
                  _createVNode("th", _hoisted_35, _toDisplayString(_ctx.$t('in')), 1),
                  _createVNode("th", _hoisted_36, _toDisplayString(_ctx.$t('out')), 1),
                  _createVNode("th", _hoisted_37, _toDisplayString(_ctx.$t('hours')), 1),
                  _createVNode("th", _hoisted_38, _toDisplayString(_ctx.$t('total_wages')), 1),
                  _createVNode("th", _hoisted_39, _toDisplayString(_ctx.$t('details')), 1),
                  _createVNode("th", _hoisted_40, _toDisplayString(_ctx.$t('attachments')), 1)
                ])
              ]),
              (_ctx.state.data.logList.logs && _ctx.state.data.logList.logs.length)
                ? (_openBlock(), _createBlock("tbody", _hoisted_41, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.logList.logs, (log, logIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: logIndex }, [
                        _createVNode("td", null, [
                          (log && log.formatedDate)
                            ? (_openBlock(), _createBlock("p", _hoisted_42, _toDisplayString(log.formatedDate), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("td", null, [
                          (log.user && log.phase && log.phase.name)
                            ? (_openBlock(), _createBlock("p", _hoisted_43, _toDisplayString(log.phase.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("td", null, [
                          (log.user && log.user.full_name)
                            ? (_openBlock(), _createBlock("p", _hoisted_44, _toDisplayString(log.user.full_name), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_45, "-"))
                        ]),
                        _createVNode("td", null, [
                          (log.user && log.user.email)
                            ? (_openBlock(), _createBlock("p", _hoisted_46, _toDisplayString(log.user.email), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_47, "-"))
                        ]),
                        _createVNode("td", null, [
                          (log && log.formatedIn)
                            ? (_openBlock(), _createBlock("p", _hoisted_48, _toDisplayString(log.formatedIn), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_49, "-"))
                        ]),
                        _createVNode("td", null, [
                          (log && log.formatedOut)
                            ? (_openBlock(), _createBlock("p", _hoisted_50, _toDisplayString(log.formatedOut), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_51, "-"))
                        ]),
                        _createVNode("td", null, [
                          (log && log.duration)
                            ? (_openBlock(), _createBlock("p", _hoisted_52, _toDisplayString(log.duration) + " hr ", 1))
                            : (_openBlock(), _createBlock("p", _hoisted_53, "-"))
                        ]),
                        _createVNode("td", null, [
                          (log && log.wage)
                            ? (_openBlock(), _createBlock("p", _hoisted_54, [
                                _createVNode("strong", null, " $ " + _toDisplayString(log.wage), 1)
                              ]))
                            : (_openBlock(), _createBlock("p", _hoisted_55, "-"))
                        ]),
                        _createVNode("td", null, [
                          (log && log.detail)
                            ? (_openBlock(), _createBlock("p", _hoisted_56, _toDisplayString(log.detail), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_57, "-"))
                        ]),
                        _createVNode("td", null, [
                          (log && log.attachments && log.attachments.length)
                            ? (_openBlock(), _createBlock("p", _hoisted_58, [
                                _createVNode("a", {
                                  id: "createNewProject",
                                  href: "javascript:void(0)",
                                  class: "btn default-btn to-upper",
                                  onClick: ($event: any) => (_ctx.selectedUser(log.attachments))
                                }, _toDisplayString(_ctx.$t('view')), 9, ["onClick"])
                              ]))
                            : (_openBlock(), _createBlock("p", _hoisted_59, "-"))
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("tbody", _hoisted_60, [
                    _createVNode("tr", null, [
                      _createVNode("td", _hoisted_61, [
                        _createVNode(_component_EmptyData, {
                          title: _ctx.state.data.title,
                          heading: _ctx.state.data.heading
                        }, null, 8, ["title", "heading"])
                      ])
                    ])
                  ]))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_62, [
          _createVNode("div", _hoisted_63, [
            _createVNode("div", _hoisted_64, [
              _createVNode("div", _hoisted_65, [
                _createVNode("div", _hoisted_66, [
                  _createVNode("h5", _hoisted_67, _toDisplayString(_ctx.$t('logs')), 1),
                  _hoisted_68
                ]),
                _createVNode("div", _hoisted_69, [
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + " :", 1),
                    _hoisted_70
                  ]),
                  _createVNode("div", _hoisted_71, [
                    _createVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('remarks')), 1),
                    _hoisted_73
                  ]),
                  _createVNode("div", _hoisted_74, [
                    _createVNode("button", _hoisted_75, _toDisplayString(_ctx.$t('start')), 1),
                    _createVNode("button", _hoisted_76, _toDisplayString(_ctx.$t('end')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_77, [
                  _createVNode("button", _hoisted_78, _toDisplayString(_ctx.$t('ok')), 1),
                  _createVNode("button", _hoisted_79, _toDisplayString(_ctx.$t('close')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_80, [
          _createVNode("div", _hoisted_81, [
            _createVNode("div", _hoisted_82, [
              _createVNode("div", _hoisted_83, [
                _createVNode("div", _hoisted_84, [
                  _createVNode("div", _hoisted_85, [
                    _createVNode("h5", _hoisted_86, _toDisplayString(_ctx.$t('attachments')), 1),
                    _createVNode("p", _hoisted_87, _toDisplayString(_ctx.$t('attachments_uploaded_on_task_complete')) + ". ", 1)
                  ]),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideTaskCompleteImages && _ctx.hideTaskCompleteImages(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_88
                  ])
                ]),
                _createVNode("div", _hoisted_89, [
                  _createVNode("div", _hoisted_90, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedUsersAttachments, (iamge, imageIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "form-group",
                        key: imageIndex
                      }, [
                        _createVNode("img", {
                          src: `${_ctx.state.data.imageBaseUrl}${iamge.link}`,
                          alt: "iamge.file_name"
                        }, null, 8, ["src"])
                      ]))
                    }), 128)),
                    _hoisted_91
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_92, [
          _createVNode("div", _hoisted_93, [
            _createVNode("div", _hoisted_94, [
              _createVNode("div", _hoisted_95, [
                _createVNode("div", _hoisted_96, [
                  _createVNode("h5", _hoisted_97, _toDisplayString(_ctx.$t('payment_request')), 1),
                  _hoisted_98
                ]),
                _createVNode("div", _hoisted_99, [
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('total_payment')) + " :", 1),
                    _hoisted_100
                  ]),
                  _createVNode("div", _hoisted_101, [
                    _createVNode("h6", _hoisted_102, _toDisplayString(_ctx.$t('history')), 1),
                    _hoisted_103,
                    _hoisted_104,
                    _createVNode("p", _hoisted_105, _toDisplayString(_ctx.$t('last_request_was_cancelled')) + ".", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_106, [
                  _createVNode("button", _hoisted_107, _toDisplayString(_ctx.$t('ok')), 1),
                  _createVNode("button", _hoisted_108, _toDisplayString(_ctx.$t('close')), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_109, [
          _createVNode("div", _hoisted_110, [
            _createVNode("div", _hoisted_111, [
              _createVNode("div", _hoisted_112, [
                _createVNode("div", _hoisted_113, [
                  _createVNode("h5", _hoisted_114, _toDisplayString(_ctx.$t('payment_approve')), 1),
                  _hoisted_115
                ]),
                _createVNode("div", _hoisted_116, [
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('total_payment')) + " :", 1),
                    _hoisted_117
                  ]),
                  _createVNode("div", _hoisted_118, [
                    _createVNode("h6", null, _toDisplayString(_ctx.$t('history')), 1),
                    _hoisted_119,
                    _hoisted_120,
                    _hoisted_121
                  ]),
                  _hoisted_122
                ]),
                _createVNode("div", _hoisted_123, [
                  _createVNode("button", _hoisted_124, _toDisplayString(_ctx.$t('approve')), 1),
                  _createVNode("button", _hoisted_125, _toDisplayString(_ctx.$t('cancel')), 1)
                ])
              ])
            ])
          ])
        ])
      ]))
}